function ProductGroup() {
    document.querySelectorAll(".prdGroups-body").forEach((group) => {
        const sliderWrap = group.querySelector(".prdGroups-slider");
        const swiperEl = sliderWrap.querySelector(".swiper"); // önemli
        const items = group.querySelectorAll(".prdGroups-item");

        const swiper = new Swiper(swiperEl, {
            direction: "vertical",
            slidesPerView: 1,
            speed: 500,
        });

        items.forEach((item, i) => {
            item.addEventListener("mouseenter", () => {
                const groupTop = group.getBoundingClientRect().top;
                const itemTop = item.getBoundingClientRect().top;

                const top = itemTop - groupTop - 48;

                sliderWrap.style.top = `${top}px`;
                swiper.slideTo(i);
            });
        });
    });
}

ProductGroup();
